import { onMounted, onUnmounted } from 'vue'

// Refresh cadence for the devcontainer slot-usage indicator (#1380). Slots
// are claimed/released on the agent box (run start, Stop, the 2h idle
// reaper), so the brain has no push signal for every transition — a coarse
// poll while the page is mounted is the safety net that keeps the count
// honest, on top of the immediate refetches after send/stop.
export const SLOT_USAGE_POLL_MS = 60_000

// Fetches slot usage on mount and then on an interval until unmount.
// Fire-and-forget like the mount-time fetches in AgentView: the store keeps
// its own loadError state, so a failed poll just leaves the last value up.
export function useSlotUsagePolling(store: { fetchUsage: () => Promise<void> }): void {
  let timer: number | undefined
  onMounted(() => {
    store.fetchUsage().catch(() => {})
    timer = window.setInterval(() => store.fetchUsage().catch(() => {}), SLOT_USAGE_POLL_MS)
  })
  onUnmounted(() => window.clearInterval(timer))
}
